/**
 * AnkhOS colour tokens. Derived from the logo: ink carries structure and
 * text, amber is reserved for the one action that matters on a screen (and
 * the hub in the mark), paper is the page.
 *
 * Both sets were checked against WCAG AA: every text-on-background pair
 * listed in public/brand/README.md and the theme canvas clears 4.5:1. Change
 * a value here only with the ratio re-checked -- the tint that looks nicer is
 * usually the one that fails.
 *
 * 🔑 The rule of amber: ONE amber element per view. Never body text, never
 * borders, never two amber buttons side by side. `secondary` is amber; keep
 * `color="secondary"` for the single call to action on a screen.
 */
export interface Tokens {
  bg: string;
  surface: string;
  surface2: string;
  border: string;
  borderStrong: string;
  text: string;
  text2: string;
  text3: string;
  link: string;
  primary: string;
  primaryHover: string;
  onPrimary: string;
  accent: string;
  accentHover: string;
  onAccent: string;
  accentSoft: string;
  success: string;
  successSoft: string;
  warning: string;
  warningSoft: string;
  error: string;
  errorSoft: string;
  info: string;
  infoSoft: string;
}

export const LIGHT: Tokens = {
  bg: "#F7F5F0",
  surface: "#FFFFFF",
  surface2: "#EEF1F5",
  border: "#E5E1D8",
  borderStrong: "#C9D0DB",
  text: "#1B2A41",
  text2: "#5B6879",
  text3: "#8A94A6",
  link: "#8A5A0C",
  primary: "#1B2A41",
  primaryHover: "#2E4262",
  onPrimary: "#F7F5F0",
  accent: "#E3A02C",
  accentHover: "#C4861C",
  onAccent: "#1B2A41",
  accentSoft: "#FBEBCB",
  success: "#237547",
  successSoft: "#DDF1E4",
  warning: "#8A5A0C",
  warningSoft: "#FBEBCB",
  error: "#B33A32",
  errorSoft: "#F9E0DD",
  info: "#2F6FB5",
  infoSoft: "#DFEAF7",
};

export const DARK: Tokens = {
  bg: "#0F1826",
  surface: "#1B2A41",
  surface2: "#24354F",
  border: "#2F415C",
  borderStrong: "#41556F",
  text: "#F7F5F0",
  text2: "#A4B0C2",
  text3: "#7A889C",
  link: "#F0B95A",
  primary: "#F7F5F0",
  primaryHover: "#FFFFFF",
  onPrimary: "#1B2A41",
  accent: "#E3A02C",
  accentHover: "#F0B95A",
  onAccent: "#1B2A41",
  accentSoft: "#3A3220",
  success: "#5FC28A",
  successSoft: "#173226",
  warning: "#F0B95A",
  warningSoft: "#3A3220",
  error: "#F08A82",
  errorSoft: "#3B1F1D",
  info: "#7FB0EA",
  infoSoft: "#1B2E47",
};
